export default {
    appTitle: "ALLU",
    common: {
        ok: "OK",
        remove: "Poista",
        view: "Katso",
        cancel: "Peruuta",
        rename: "Nimeä uudelleen",
        copyright: "Copyright 2018 ALLU Finland Oy\r\nKaikki oikeudet pidätetään.",
        contactInfo: {
            address: "Jokimäentie 1,\r\n16320 Pennala",
            phone: "Puh: ",
            fax: "Faksi: +358 8 882 1440",
            email: "S-posti: ",
        },
        yes: "Kyllä",
        name: "Nimi",
        now: "Nyt",
        downloadFile: "Lataa tiedosto",
        save: "Tallenna",
        new: "Uusi",
        login: "Kirjaudu",
        email: "Sähköposti",
        termsOfService: "Käyttöehdot",
        country: "Maa",
        message: "Viesti",
        send: "Lähetä",
        scrollIndicator: "Selaa alaspäin lukeaksesi lisää",
        close: "Sulje"
    },
    language: {
        cs: "Czech",
        de: "German",
        ee: "Estonian",
        en: "English",
        es: "Spanish",
        fi: "Finnish",
        fr: "French",
        hu: "Hungarian",
        it: "Italian",
        nl: "Dutch",
        no: "Norwegian",
        pl: "Polish",
        pt: "Portuguese",
        ru: "Russian",
        se: "Swedish",
        tr: "Turkish",
        zh: "Chinese",
    },
    error: {
        UNKNOWN_BLUETOOTH: "Tuntematon Bluetooth virhe tapahtui. ({0}: {1})",
        TIMEOUT: "Toiminto aikakatkaistiin.",
        BLE_NOT_AVAILABLE: "Tämä laite ei tue Bluetooth low energyä, joten Bluetooth toiminnot eivät ole saatavilla.",
        BLE_NOT_ENABLED: "Bluetooth on poissa käytöstä. Ota Bluetooth käyttöön laiteesi asetuksista käyttääksesi tätä toimintoa.",
        PERMISSION_DENIED: "Et hyväksynyt käyttöoikeuspyyntöä, joten tämä toiminto ei ole käytössä",
        DEVICE_NOT_FOUND: "Tuotetta ei löytynyt. Varmista, että tuote on Bluetooth alueella ja yritä uudelleen.",
        CONNECTION_FAILED: "Bluetooth yhdistäminen epäonnistui.",
        INTERNET_CONNECTION_ERROR: "Yhteys palvelimeen epäonnistui. Yritä uudelleen myöhemmin.",
    },
    startView: {
        title: "Home",
    },
    contactView: {
        title: "Ota yhteyttä",
        locateNearestDealer: "Etsi lähin jälleenmyyjä",
        nearestDealer: "Lähin ALLU-jälleenmyyjäsi",
        alluDistributors: "ALLU jälleenmyyjät",
        contactUs: "Ota yhteyttä",
        validationError: "Olkaa hyvä, ja täyttäkää kaikki kentät.",
        sendSuccess: "Viestinne lähetettiin. Olemme piakkoin yhteydessä!",
        sendError: "Viestiä ei voitu lähettää. Olkaa hyvä ja tarkistakaa internet-yhteytenne.",
        locateNearestDealerFailed: "Lähimmän jälleenmyyjän haku epäonnistui.",
    },
    addDevice: {
        typeSerialNumber: "Kirjoita sarjanumero",
        add: "Lisää",
        showDevice: "Näytä laite",
        errorSerialRequired: "Lisätkää sarjanumero.",
        errorSerialExists: "Olette jo lisänneet tämän koneen. Haluatteko katsoa sen tietoja?",
        errorSerialNotFound: "Sarjanumeroa ei löytynyt.",
        nearby: "Lähellä",
        nearbyInfo: "Etsi lähellä olevia ALLU tuotteita Bluetoothilla.",
        searchForNearbyDevices: "Etsi laitteita",
        searching: "Etsitään",
        noNearbyDevices: "Laitteita ei löytynyt",
    },
    addDeviceView: {
        title: "Lisää ALLU tuote",
    },
    deviceApplicationsView: {
        title: "Käyttökohteet",
    },
    deviceView: {
        specifications: "Tekniset tiedot",
        documents: "Dokumentit",
        applications: "Käyttökohteet",
        removeDevice: "Poista Omista Laitteista",
        confirmRemoveDevice: "Oletteko varma, että haluatte poistaa tämän koneen tiedoistanne?",
        renameHelp: "Kirjatkaa uusi nimi koneellenne:",
    },
    deviceApplicationView: {
        noApplications: "Käyttökohdemediaa ei ole vielä lisätty.",
    },
    deviceStartView: {
        registerDevice: "Rekisteröi laite",
        limitedAccess: "Et ole rekisteröinyt tätä laitetta. Tietoja on rajoitetusti saatavilla.",
        pending: "Rekisteröintipyyntösi odottaa hyväksymistä.",
        pendingDeviceTitle: "KÄYTTÖOIKEUSPYYNNÖT LAITTEELLE",
        deny: "Hylkää",
        allow: "Hyväksy"
    },
    deviceListView: {
        title: "Minun ALLUni",
        noDevices: "Ette ole lisänneet ALLU-tuotetta vielä.",
        addDevice: "Lisää tuotteen sarjanumero",
        deviceRemoved: "Yksi tai useampi kone on poistettu listasta, koska ne ovat poistettu ALLU:n rekisteristä.",
        nearby: "LÄHELLÄ",
        searchDevices: "Etsi lähellä olevia ALLU tuotteita. Varmasti, että bluetooth on aktiivinen.",
        search: "ETSI",
        registerToView: "Rekisteröidy nähdäksesi yksityiskohdat",
        pendingRequests: "odottavaa pyyntöä",
        loadingDevices: "Ladataan laitteita",
    },
    deviceSpecificationsView: {
        title: "Tuotteen tiedot",
        wheelLoaderWeight: "Suositeltava pyöräkuormaajan painorajoitus",
        excavatorWeight: "Suositeltava kaivinkoneen painorajoitus",
        partsList: "Osalista",
        part: "Osa",
        partNumber: "Osanumero",
        limitedInformationAvailable: "Tälle tuotteelle on rajoitetusti tietoa saatavilla.",
        pcs: "Kpl",
        showAllParts: "Näytä kaikki osat"
    },
    deviceServiceOperationsView: {
        title: "Huoltotoiminnot"
    },
    deviceTroubleshootingView: {
        title: "Ongelmien kartoitus"
    },
    deviceLocationView: {
        title: "Sijainti",
        date: "Päiväys",
        service: "Huolto",
        sensor: "Käyttötiedot",
        locationNotAvailable: "Viimeistä sijaintia ei ole saatavilla.",
        previous: "Edellinen",
        next: "Seuraava",
        none: "Ei ole"
    },
    deviceDocumentView: {
        mustReadWarning: "Olkaa hyvä ja lukekaa dokumentti ennen jatkamista.",
        doneReading: "Olen lukenut dokumentin",
    },
    deviceInfo: {
        serial: "Sarjanumero",
        name: "Nimi",
        bucket: "Runko",
        drum: "Rumpu",
        isProject: "Projektikone",
        weight: "Paino (ilman lisälaitteita)",
        width: "Leveys",
        height: "Korkeus",
        lenght: "Pituus",
        maxPressure: "Paine max",
        maxFlow: "Virtaus max",
        minFlow: "Virtaus min"
    },
    deviceRuntimeReports: {
        title: "Käyttöraportti",
        chooseCharts: "Valitse graafit",
        cumulativeUsage: "Kumulatiivinen käyttö",
        usagePerDay: "Käyttö päivittäin",
        usagePerDayAverage: "Keskiarvo päivittäin",
        usagePerWeek: "Käyttö viikkottain",
        usagePerMonth: "Käyttö kuukausittain",
        batteryLevelPerDay: "Patterin taso päivittäin",
        temperaturePerWeek: "Lämpötila ",
        assetByCalender: "Päiväkohtainen käyttö ",
        assetByWorkTime: "Työaikakohtainen käyttö ",
        legendTimeDay: "Aika [päivä]",
        legendTimeDayOfWeek: "Aika [viikonpäivä]",
        legendTimeWeek: "Aika [viikko]",
        legendTimeMonth: "Aika [kuukausi]",
        legendRuntimeHour: "Kesto [tuntia]",
        legendRuntimePercent: "Runtime [%]",
        changeFilters: "Vaihda graafia",
        legendTemperatureWeek: "Lämpötila [°C]",
        legendBatteryLevel: "Taso [%]",
        statisticsTitle: "Paras",
        colTime: "Aika",
        colRuntime: "Runtime",
        colAverage: "Keskiarvo",
        rowMonth: "Kuukausi",
        rowWeek: "Viikko",
        rowDay: "Päivä",
        searching: "Etsitään...",
        noData: "Käyttöraportteja ei ole saatavilla."
    },
    deviceDocumentationView: {
        title: "Dokumentaatio"
    },
    deviceMaintenance: {
        title: "Huolto",
        sendServiceData: "Lähetä huoltotiedot",
        viewServiceRecord: "Näytä huoltotiedot",
        setupServiceParameters: "Aseta huoltovälit",
        showTransformerLocation: "Näytä sijainti",
        specification: "Spesifikaatiot",
        partsList: "Osalista",
        troubleshooting: "Ongelmien kartoitus",
        warrantyInfo: "Takuutiedot",
        serviceBladeChange: "Terä",
        serviceGreasing: "Rasvaus",
        serviceChainDriveChange: "Ketjuvälitys",
        serviceMotorChange: "Moottori",
        serviceCounterBladeChange: "Vastaterä",
    },
    deviceSendServiceDataView: {
        title: "Lähetä huoltotiedot",
        chooseService: "Valitse huolto",
        sent: "Huoltotiedot on lähetetty",
        addComment: "Lisää komentti (valinnainen)",
        errorSendingData: "Virhe tietojen lähetyksessä. Yritä uudelleen myöhemmin.",
        checked: "Tarkistettu",
        changed: "Vaihdettu",
        runtime: "Runtime",
        limitedFeaturesAvailable: "Tälle tuotteelle on rajoitetusti toimintoja saatavilla."
    },
    deviceViewServiceRecordView: {
        title: "Huoltotiedot",
        runtime: "Runtime",
        lastService: "Viimeisin huoltopäivä",
        nextService: "Arvioitu huoltopäivä",
        hoursUntilNextService: "Tuntia seuraavaan huoltoon",
        noData: "Huoltotietoja ei ole saatavilla.",
        searching: "Etsitään..."
    },
    setupServiceParametersView: {
        title: "Aseta huoltoväli",
        resetFactoryDefaults: "Palauta oletusasetukset"
    },
    deviceSetupServiceParametersView: {
        title: "Aseta huoltovälit",
        saved: "Huoltovälit on tallennettu",
        runtime: "Runtime",
        resetFactoryDefaults: "Palauta oletusasetukset",
        limitedFeaturesAvailable: "Tälle tuotteelle on rajoitetusti toimintoja saatavilla."
    },
    transformerLocationView: {
        title: "Transformer location"
    },
    deviceWarrantyInfoView: {
        title: "Takuutiedot",
        registrationStatus: "Rekisteröinnin tila",
        registered: "Rekisteröity",
        unregistered: "Rekisteröimätön",
        validity: "Voimassaolo",
        validUntil: "Voimassa",
        expiredOn: "Vanhentunut",
        invalid: "Väärä"
    },
    partsListView: {
        title: "Osalista"
    },
    nearestDealerView: {
        title: "Lähin jälleenmyyjä",
    },
    loginView: {
        title: "Kirjaudu ALLU ID:llä",
        newUser: "Uusi ALLU käyttäjä?",
        pin: "PIN",
        confirmWithPin: "Olemme lähettäneet PIN-numeron sähköpostiisi. Kirjaudu kirjoittamalla PIN.",
        createAccount: "Luo tili",
        errorEmail: "Sähköpostia ei löydy",
        errorPin: "Väärä PIN"
    },
    safetyGuideView: {
        title: "Turvallisuusohje",
    },
    transformerWorkingAngleView: {
        title: "Transformer työkulma"
    },
    deviceOperatingDataView: {
        title: "Käyttötiedot"
    },
    deviceQuickGuidesView: {
        title: "Pikaohjeet"
    },
    termsOfServiceView: {
        title: "Käyttöehdot",
    },
    registerDeviceView: {
        title: "Rekisteröi laite",
        chooseNewCompany: "Valitse toinen yritys",
        register: "Rekisteröi",
        company: "Yritys",
        registerDevice: "Rekisteröi laite",
        registrationRequired: "Sinun täytyy kirjautua tai rekisteröityä ennen tämän laiteen rekisteröimistä.",
        errorRegisteringDevice: "Virhe laitteen rekisteröinnissä. Yritä uudelleen tai ota yhteyttä ylläpitäjään.",
        alreadyRegistered: "Tämä laite on jo rekisteröity toiselle käyttäjälle. Voit lähettää käyttöoikeuspyynnön tämän laitteen rekisteröimiseksi.",
        sendRequest: "LÄHETÄ PYYNTÖ",
        sended: "Pyyntö lähetettiin onnistuneesti.",
        sendFailed: "Pyynnön lähettäminen epäonnistui. Yritä uudelleen myöhemmin."
    },
    registerUserView: {
        title: "Rekisteröinti",
        givenName: "Etunimi",
        familyName: "Sukunimi",
        email: "Sähköposti",
        company: "Yritys",
        register: "rekisteröi",
        alreadyRegistered: "Sähköposti on jo rekisteröity.",
    },
    saveSensorLog: {
        save: "Tallenna käyttötiedot",
        completed: "Käyttötiedot tallennettu",
        lastSavedFormat: "Viimeksi tallennettu: {0}",
        status: {
            scanning: "Etsitään lähellä olevia tuotteita",
            connecting: "Yhdistetään",
            connectingAttempt: "Yhdistetään (yritys {0})",
            downloading: "Luetaan tietoja sensorilta",
            uploading: "Lähetetään tietoa palvelimelle",
            completed: "Valmis",
            error: "Virhe tapahtui.",
        },
    },
    inviteUserView: {
        title: "Kutsu käyttäjä",
        email: "Sähköposti",
        button: "Kutsu",
        invited: "Tätä sähköpostia ei ole rekisteröity vielä. Kun sähköposti rekisteröidään tämä laite lisätään käyttäjälle.",
        alreadyAdded: "Laite oli jo lisätty käyttäjälle.",
        inviteexits: "Kutsu on jo lähetetty käyttäjälle.",
        deviceAdded: "Laite on nyt lisätty käyttäjälle."
    }
};
